const AppConfig = {
  state: {
    imgPath: process.env.VUE_APP_IMG_URL,
    pageNumber: 0,
  },
  mutations: {
    'APP_CONFIG/SET_PAGE': function(state, payload) {
      //console.log(payload);
      state.pageNumber = payload;
    },
  },
};

export default AppConfig;
